import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "pa-4" }
const _hoisted_3 = {
  class: "pa-4",
  style: {"color":"white"}
}
const _hoisted_4 = { class: "py-6 text-center" }
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_my_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString($props.name) + "邀请您绑定设备,绑定后您可以获取睡眠报告、查看助眠知识,参与睡眠优化计划等. ", 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: $props.url,
              style: {"width":"70vw","height":"70vw"}
            }, null, 8, _hoisted_5)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}